module.exports = __webpack_public_path__ + "img/menu-icon-6-1.3bef2c7b.svg";